import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

import { androidMarginTop } from './helpers';

export const styles = StyleSheet.create({
  black: {
    fontFamily: 'Roboto-Black',
  },
  bold: {
    fontFamily: 'Roboto-Bold',
  },
  condensed: {
    fontFamily: 'RobotoCondensed-Regular',
  },
  condensedBold: {
    fontFamily: 'RobotoCondensed-Bold',
  },
  condensedLight: {
    fontFamily: 'RobotoCondensed-Light',
  },
  light: {
    fontFamily: 'Roboto-Light',
  },
  medium: {
    fontFamily: 'Roboto-Medium',
  },
  regular: {
    fontFamily: 'Roboto-Regular',
  },
  roboto: {
    fontFamily: 'Roboto',
  },
  thin: {
    fontFamily: 'Roboto-Thin',
  },
});

export const variants = StyleSheet.create({
  anfTileTitle: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Black',
    fontSize: Theme.px(24),
    lineHeight: Theme.px(33),
    marginTop: androidMarginTop(24),
    paddingBottom: Theme.px(5),
    paddingLeft: Theme.px(12),
    paddingRight: Theme.px(12),
    paddingTop: Theme.px(4),
  },
  boldText24: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Bold',
    fontSize: Theme.px(24),
    marginTop: androidMarginTop(24),
  },
  boldText30: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Bold',
    fontSize: Theme.px(30),
    marginTop: androidMarginTop(30),
  },
  boldText48: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Bold',
    fontSize: Theme.px(48),
    marginTop: androidMarginTop(48),
  },
  boldText54: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Bold',
    fontSize: Theme.px(54),
    marginTop: androidMarginTop(54),
  },
  boldText66: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Bold',
    fontSize: Theme.px(66),
    marginTop: androidMarginTop(66),
  },
  changeMapButton: {
    color: Theme.blackPearlBlue,
    fontFamily: 'Roboto-Regular',
    fontSize: Theme.px(36),
    marginTop: androidMarginTop(36),
  },
  changeMapHeader: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Regular',
    fontSize: Theme.px(42),
    marginTop: androidMarginTop(42),
  },
  condensedText36: {
    color: Theme.mainText,
    fontFamily: 'RobotoCondensed-Regular',
    fontSize: Theme.px(36),
    marginTop: androidMarginTop(36),
  },
  condensedText36Transparent: {
    color: Theme.withOpacity(Theme.mainText, 0.6),
    fontFamily: 'RobotoCondensed-Regular',
    fontSize: Theme.px(36),
    marginTop: androidMarginTop(36),
  },
  largeText: {
    color: Theme.mainText,
    fontSize: Theme.px(112),
    marginTop: androidMarginTop(112),
  },
  /**
   * For the map loading text.  Is currently the same as regularText24Transparent.
   * Considered making that style name more generic and using the same in both
   * places, but decided to separate it out in case the styles diverge in the future.
   */
  mapLoadingText: {
    color: Theme.withOpacity(Theme.mainText, 0.6),
    fontSize: Theme.px(60),
    marginTop: androidMarginTop(60),
  },
  medium: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(36),
    marginTop: androidMarginTop(36),
  },
  mediumCondensed: {
    color: Theme.mainText,
    fontFamily: 'RobotoCondensed-Regular',
    fontSize: Theme.px(36),
    marginTop: androidMarginTop(36),
  },
  mediumText18: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(18),
    marginTop: androidMarginTop(18),
  },
  mediumText24: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(24),
    marginTop: androidMarginTop(24),
  },
  mediumText28: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(28),
    marginTop: androidMarginTop(28),
  },
  mediumText30: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(30),
    marginTop: androidMarginTop(30),
  },
  mediumText30Subheader: {
    color: Theme.withOpacity(Theme.mainText, 0.6),
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(30),
    marginTop: androidMarginTop(30),
  },
  mediumText36: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(36),
    marginTop: androidMarginTop(36),
  },
  mediumText40: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(40),
    marginTop: androidMarginTop(40),
  },
  mediumText42: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(42),
    marginTop: androidMarginTop(42),
  },
  mediumText44: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(44),
    marginTop: androidMarginTop(44),
  },
  mediumText48: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(48),
    marginTop: androidMarginTop(48),
  },
  mediumText50: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(50),
    marginTop: androidMarginTop(50),
  },
  mediumText54: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(54),
    marginTop: androidMarginTop(54),
  },
  mediumText60: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(60),
    marginTop: androidMarginTop(60),
  },
  pageHeader: {
    color: Theme.mainText,
    fontSize: Theme.px(66),
    marginTop: androidMarginTop(66),
  },
  regularText: {
    color: Theme.mainText,
    fontSize: Theme.px(32),
    marginTop: androidMarginTop(32),
  },
  /**
   * There are so many random text sizes in XD, ideally we will be able to standardize this/have an actual typography system...
   */
  regularText12: {
    color: Theme.mainText,
    fontSize: Theme.px(12),
    marginTop: androidMarginTop(12),
  },
  regularText18: {
    color: Theme.mainText,
    fontSize: Theme.px(18),
    marginTop: androidMarginTop(18),
  },
  regularText20: {
    color: Theme.mainText,
    fontSize: Theme.px(20),
    marginTop: androidMarginTop(20),
  },
  regularText22: {
    color: Theme.mainText,
    fontSize: Theme.px(22),
    marginTop: androidMarginTop(22),
  },
  regularText24: {
    color: Theme.mainText,
    fontSize: Theme.px(24),
    marginTop: androidMarginTop(24),
  },
  regularText24Transparent: {
    color: Theme.withOpacity(Theme.mainText, 0.6),
    fontSize: Theme.px(24),
    marginTop: androidMarginTop(24),
  },
  regularText26: {
    color: Theme.mainText,
    fontSize: Theme.px(26),
    marginTop: androidMarginTop(26),
  },
  regularText28: {
    color: Theme.mainText,
    fontSize: Theme.px(28),
    marginTop: androidMarginTop(28),
  },
  regularText29: {
    color: Theme.mainText,
    fontSize: Theme.px(29),
    marginTop: androidMarginTop(29),
  },
  regularText30: {
    color: Theme.mainText,
    fontSize: Theme.px(30),
    marginTop: androidMarginTop(30),
  },
  regularText30LessTransparent: {
    color: Theme.withOpacity(Theme.mainText, 0.7),
    fontSize: Theme.px(30),
    marginTop: androidMarginTop(30),
  },
  regularText30Transparent: {
    color: Theme.withOpacity(Theme.mainText, 0.6),
    fontSize: Theme.px(30),
    marginTop: androidMarginTop(30),
  },
  regularText34: {
    color: Theme.mainText,
    fontSize: Theme.px(34),
    marginTop: androidMarginTop(34),
  },
  regularText36: {
    color: Theme.mainText,
    fontSize: Theme.px(36),
    marginTop: androidMarginTop(36),
  },
  regularText36Transparent: {
    color: Theme.withOpacity(Theme.mainText, 0.6),
    fontSize: Theme.px(36),
    marginTop: androidMarginTop(36),
  },
  regularText42: {
    color: Theme.mainText,
    fontSize: Theme.px(42),
    marginTop: androidMarginTop(42),
  },
  regularText42Transparent: {
    color: Theme.withOpacity(Theme.mainText, 0.5),
    fontSize: Theme.px(42),
    marginTop: androidMarginTop(42),
  },
  regularText44: {
    color: Theme.mainText,
    fontSize: Theme.px(44),
    marginTop: androidMarginTop(44),
  },
  regularText48: {
    color: Theme.mainText,
    fontSize: Theme.px(48),
    marginTop: androidMarginTop(48),
  },
  regularText54: {
    color: Theme.mainText,
    fontSize: Theme.px(54),
    marginTop: androidMarginTop(54),
  },
  regularText60: {
    color: Theme.mainText,
    fontSize: Theme.px(60),
    marginTop: androidMarginTop(60),
  },
  regularText66: {
    color: Theme.mainText,
    fontSize: Theme.px(66),
    marginTop: androidMarginTop(66),
  },
  regularText80: {
    color: Theme.mainText,
    fontSize: Theme.px(80),
    marginTop: androidMarginTop(80),
  },
  regularText90: {
    color: Theme.mainText,
    fontSize: Theme.px(90),
    marginTop: androidMarginTop(90),
  },
  tileHeader: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(24),
    marginTop: androidMarginTop(24),
  },
  tileSubheader: {
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(16),
    marginTop: androidMarginTop(16),
  },
});
